import { FormToggleButton } from "../../../../../../components/fields";
import { Lock, LockOpen } from "@mui/icons-material";
import { useWatch, useFormContext } from "react-hook-form";
import { IFormValues } from "../../../../types";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { editPendingBookingRce } from "../../../../recoil";
const LockGroup = () => {

    const formContext = useFormContext<IFormValues>();

    const lockGroup = useWatch<IFormValues, "basicDetails.lockGroup">({
        name: 'basicDetails.lockGroup'
    });

    const isPendingBookingRce = useRecoilValue<boolean | undefined>(editPendingBookingRce);

    const carGroup = useWatch<IFormValues, "basicDetails.carGroup">({
        name: 'basicDetails.carGroup'
    });

    useEffect(() => {
        if (!carGroup) {
            formContext.resetField('basicDetails.lockGroup')
        }
    }, [carGroup]);

    return (
        <FormToggleButton<IFormValues>
            name="basicDetails.lockGroup"
            disabled={!carGroup || isPendingBookingRce}
        >
            {lockGroup ? <Lock /> : <LockOpen />}
        </FormToggleButton >
    );
};

export default LockGroup;
